import { Injectable } from "@angular/core";
import Api from "app/helpers/api";
import { take } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})

export class PermissionService {
  constructor(private api: Api) {}

  apiCall = this.api.new().silent();

  /**
   * Fetchess employee data by company
   */
  getPermissoes() {
    console.log("Iniciando chamada à API de Cidades...");
   return this.apiCall.get(`permissoes`).pipe(take(1)).toPromise()
  }

  getPermissoesByCidade(idCidade: number, params: any = {}) {
    console.log("Iniciando chamada à API de Cidades...");
   return this.apiCall.get(`permissoes/getPermissoes/${idCidade}`).pipe(take(1)).toPromise()
  }


 
}